import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.primary,
    },
    headline: {
      color: theme.palette.secondary.main,
    },
    assetModalCaption: {
      color: theme.palette.primary.main,
    },
    dashboardCaption: {
      fontSize: '120%',
      color: theme.palette.secondary.main,
    },
    modalTitle: {
      color: 'red',
      fontSize: '3em',
    },
    menuContainer: {
      textAlign: 'center',
    },
    menuItem: {
      paddingTop: '5px',
      border: '2px solid' + theme.palette.primary.main,
      borderRadius: '4px',
      cursor: 'pointer',
      width: '200px',
      height: '120px',
      textAlign: 'center',
      '&:hover': {
        borderWidth: '4px',
      },
    },
    menuItemContent: {
      // position: 'relative',
      /* top: 10, */
      // color: theme.palette.primary.main,
      textAlign: 'center',
    },
  }),
);
